module.exports = __webpack_public_path__ + "static/OracleCommunity-44f9f5eb114ffaecf80ac8aedc2f8f53.jpg";